import React from 'react';
import copyIbanButton from 'assets/icons/identity/icon-copy.svg';
import PropTypes from 'prop-types';
import { formatText } from 'core/i18n';
import './CopyIbanButton.scss';
import { InfoTooltip } from 'components/tooltip/tooltip';

export const CopyIbanButton = ({ handleCopyIban }) => {
    return (
        <InfoTooltip icon={null} text={formatText('identityTransfer-copyIbanSucess')} triggerEvent={handleCopyIban}>
            <span className="copy-iban-container">
                <img src={copyIbanButton} alt={'copy-iban'} className="copy-iban-container-image" />
                <span className="copy-iban-container-text">{formatText('button-copyIban')}</span>
            </span>
        </InfoTooltip>
    );
};

CopyIbanButton.propTypes = {
    handleCopyIban: PropTypes.func.isRequired,
};
